import URI from 'jsuri';

import { getAnswerApi, getQuestionApi } from 'bundles/discussions/api/forumApiChoiceUtil';
import { forumAnswerBadgeTagType } from 'bundles/discussions/constants';

const getApi = (post: $TSFixMe) =>
  post.type === 'question' ? getQuestionApi(post.forumType) : getAnswerApi(post.forumType);

export const editThread = (
  questionId: $TSFixMe,
  question: $TSFixMe,
  details: $TSFixMe,
  reason: $TSFixMe,
  dontNotify: $TSFixMe,
  forumType: $TSFixMe
) => {
  const uri = new URI(questionId);

  return Promise.resolve(
    getQuestionApi(forumType).put(uri.toString(), {
      data: {
        content: { question, details },
        moderationSetting: reason
          ? {
              stateReason: reason,
              sendModerationNotificationToCreator: !dontNotify,
            }
          : undefined,
      },
    })
  );
};

export const editReply = (reply: $TSFixMe, content: $TSFixMe) => {
  const uri = new URI(reply.id);

  return Promise.resolve(
    getAnswerApi(reply.forumType).put(uri.toString(), {
      data: {
        content,
        moderationSetting: reply.editReason
          ? {
              stateReason: reply.editReason,
              sendModerationNotificationToCreator: !reply.dontNotify,
            }
          : undefined,
      },
    })
  );
};

export const deletePost = (post: $TSFixMe, reason: $TSFixMe, dontNotify: $TSFixMe) => {
  // TODO add noModerationEmail when that is added to the spec
  const uri = new URI(post.id);

  return Promise.resolve(
    getApi(post).delete(uri.toString(), {
      data: {
        moderationSetting: reason
          ? {
              stateReason: reason,
              sendModerationNotificationToCreator: !dontNotify,
            }
          : undefined,
      },
    })
  );
};

export const undoDelete = (post: $TSFixMe, userId: $TSFixMe) => {
  const uri = new URI().addQueryParam('action', 'undoDelete').addQueryParam('id', post.id);

  return Promise.resolve(getApi(post).post(uri.toString(), { data: { userId } }));
};

export const highlightPost = (post: $TSFixMe) => {
  const uri = new URI().addQueryParam('id', post.id).addQueryParam('action', 'addForumAnswerBadge');

  return Promise.resolve(
    getAnswerApi(post.forumType).post(uri.toString(), {
      data: { forumAnswerBadgeTagType },
    })
  );
};

export const unhighlightPost = (post: $TSFixMe) => {
  const uri = new URI().addQueryParam('id', post.id).addQueryParam('action', 'removeForumAnswerBadge');

  return Promise.resolve(
    getAnswerApi(post.forumType).post(uri.toString(), {
      data: { forumAnswerBadgeTagType },
    })
  );
};

export const moveQuestion = (
  questionId: $TSFixMe,
  courseId: $TSFixMe,
  forumId: $TSFixMe,
  forumType: $TSFixMe,
  userId: $TSFixMe
) => {
  const uri = new URI().addQueryParam('action', 'move').addQueryParam('id', questionId);

  return Promise.resolve(
    getQuestionApi(forumType).post(uri.toString(), {
      data: {
        userId,
        moderationSetting: {
          sendModerationNotificationToCreator: true,
        },
        newCourseForumId: courseId + '~' + forumId,
      },
    })
  );
};
